import dayjs from 'dayjs';

/**
 * [getFutureDateObject] Future is the start of the next month until the end of 1 year out
 * e.g. October -> 11/1/2020 to 10/31/2021
 * @returns {{min: number, max: number}}  returns an object with min as the next month
 * in YYYYMMDD format, and max as the end of 1 year out in YYYYMMDD format
 */
export const getFutureDateRange = () => {
  return {
    min: dayjs().startOf('month').add(1, 'month').format('YYYYMMDD'),
    max: dayjs().endOf('month').add(12, 'month').format('YYYYMMDD'),
  };
};
